export default {
  buttons: {
    go_to_basket: 'Gå til kurven',
  },
};
